import { Components, Theme } from "@mui/material";
import { typography } from "../typography";

export const MuiTextField: Components<Theme>["MuiTextField"] = {
  styleOverrides: {
    root: {
      background: "#fff",
      border: "1px solid #D7DEF8",
      alignItems: "center",
      borderRadius: ".5rem",
      ...typography.formInput,
    },
  },
};
